import React from 'react';

var img1 = require('./../../images/background/bg-6.png');
var img2 = require('./../../images/background/line.png');

class AboutSummary extends React.Component {
    componentDidMount(){
        function loadScript(src) {
           
          return new Promise(function(resolve, reject){
            var script = document.createElement('script');
            script.src = src;
            script.addEventListener('load', function () {
              resolve();
            });
            script.addEventListener('error', function (e) {
              reject(e);
            });
            document.body.appendChild(script);
            document.body.removeChild(script);
          })
        };
 
      loadScript('./assets/js/masonary.js');
      
    };
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b80 bg-dark bg-repeat square_shape2 inner-page-padding" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                    <div className="container">
                        {/* TITLE START */}
                        <div className="section-head">
                            <div className="mt-separator-outer separator-left">
                                <div className="mt-separator text-white">
                                    <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Krótka</span> historia</h2>
                                </div>
                            </div>
                        </div>
                        {/* TITLE END */}
                        <div className="section-content our-story">
                            <div className="row">
                                <div className="col-md-4 col-sm-6">
                                    <div className="our-story-pic-block">
                                        <div className="mt-media our-story-pic">
                                            <img src={require("./../../images/gallery/story/2015 - otwarcie szkółki i wypożyczalni rolek.jpg")} alt=""/>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 col-sm-6">
                                    <div className="mt-box our-story-detail bg-moving bg-cover" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                        <h4 className="text-uppercase m-b20">1997</h4>
                                        <h4 className="m-b20">Przełomowy moment</h4>
                                        <p>Dzień, w którym Przemek Kepiński, założyciel i obecny prezes Skate Arena, otrzymał od swojego wujka pierwsze rolki, okazał się przełomem, który zaważył na reszcie jego życia.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 col-sm-6">
                                    <div className="our-story-pic-block">
                                        <div className="mt-media our-story-pic">
                                            <img src={require("./../../images/gallery/story/2017 - otwarcie sklepu bladeville.jpg")} alt=""/>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 col-sm-6">
                                    <div className="mt-box our-story-detail bg-moving bg-cover" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                        <h4 className="text-uppercase m-b20">1997-2015</h4>
                                        <h4 className="m-b20">Szlifowanie umiejętności i udział w społeczności rolkowej</h4>
                                        <p>Przemek cały czas jeździł na rolkach szlifując umiejętności, brał udział w różnych zawodach, niektóre z nich wygrywał, wykonując niespotykane triki.Poznawał wspaniałych ludzi dzielących z nim pasję. Pracował przy budowie skateparków i na maszynie CNC. Poznał Paulinę Cwynar, która stała się jego partnerką życiową i biznesową.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 col-sm-6">
                                    <div className="our-story-pic-block">
                                        <div className="mt-media our-story-pic">
                                            
                                            <img src={require("./../../images/gallery/story/2015 - otwarcie szkółki i wypożyczalni rolek.jpg")} alt="2015 - otwarcie szkółki i wypożyczalni rolek"/>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 col-sm-6">
                                    <div className="mt-box our-story-detail bg-moving bg-cover" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                        <h4 className="text-uppercase m-b20">2015</h4>
                                        <h4 className="m-b20">Rejestracja działalności Roll4All</h4>
                                        <p>Założyliśmy działalność z pasji do sportów ekstremalnych i marzeń o stworzeniu miejsca, które połączy miłośników rolek, deskorolek i BMX-ów. Nasza misja od początku była jasna: chcieliśmy dostarczać sprzęt najwyższej jakości oraz budować miejsca, gdzie pasjonaci będą mogli doskonalić swoje umiejętności.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 col-sm-6">
                                    <div className="our-story-pic-block">
                                        <div className="mt-media our-story-pic">
                                        <img src={require("./../../images/gallery/story/2017 - otwarcie sklepu bladeville.jpg")} alt="2017 - otwarcie sklepu bladeville"/>
                                           
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 col-sm-6">
                                    <div className="mt-box our-story-detail bg-moving bg-cover" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                        <h4 className="text-uppercase m-b20">2017</h4>
                                        <h4 className="m-b20">Otwarcie sklepu Bladevile</h4>
                                        <p>Otwarcie naszego pierwszego sklepu z rolkami było kolejnym krokiem w realizacji naszego celu. Dzięki temu mogliśmy dostarczać sprzęt najwyższej jakości naszym klientom. Sklep stał się miejscem spotkań społeczności rolkowej, gdzie wymienialiśmy się doświadczeniami i inspirowaliśmy nawzajem.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">0
                                <div className="col-md-4 col-sm-6">
                                    <div className="our-story-pic-block">
                                        <div className="mt-media our-story-pic">
                                        <img src={require("./../../images/gallery/story/2018 otwarcie skate arena.jpg")} alt=""/>
                                           
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 col-sm-6">
                                    <div className="mt-box our-story-detail bg-moving bg-cover" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                        <h4 className="text-uppercase m-b20">2018</h4>
                                        <h4 className="m-b20">Otwarcie SkateArena</h4>
                                        <p>W Gdańsku otworzyliśmy nasz pierwszy skatepark. Wszystkie przeszkody zbudowaliśmy sami, co pozwoliło nam na stworzenie unikalnego miejsca idealnie dopasowanego do potrzeb użytkowników. Byliśmy dumni z tego, że nasze rękodzieło stało się miejscem codziennych treningów i zawodów.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 col-sm-6">
                                    <div className="our-story-pic-block">
                                        <div className="mt-media our-story-pic">
                                            
                                            <img src={require("./../../images/gallery/story/2020 - pandemia.jpg")} alt=""/>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 col-sm-6">
                                    <div className="mt-box our-story-detail bg-moving bg-cover" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                        <h4 className="text-uppercase m-b20">2020</h4>
                                        <h4 className="m-b20">Dostosowanie do pandemii</h4>
                                        <p>Pandemia zmieniła rzeczywistość, ale my dostosowaliśmy się do nowych warunków. Rozpoczęliśmy produkcję mobilnych przeszkód do ogrodu, aby nasi klienci mogli ćwiczyć i rozwijać swoje umiejętności w domowym zaciszu podczas lockdownu. Ta innowacja okazała się strzałem w dziesiątkę i pozwoliła nam przetrwać trudne czasy.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 col-sm-6">
                                    <div className="our-story-pic-block">
                                        <div className="mt-media our-story-pic">
                                        <img src={require("./../../images/gallery/story/2020 - mińsk mazowiecki.jpg")} alt=""/>
                                         
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 col-sm-6">
                                    <div className="mt-box our-story-detail bg-moving bg-cover" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                        <h4 className="text-uppercase m-b20">2020</h4>
                                        <h4 className="m-b20">Projekt skateparku w Mińsku Mazowieckim</h4>
                                        <p>Tuż przed wybuchem pandemii zrealizowaliśmy nasz pierwszy duży projekt - skatepark dla Mińska Mazowieckiego. Był to przełomowy moment w historii naszej firmy. Z dumą patrzyliśmy, jak nasze dzieło staje się miejscem spotkań i rywalizacji dla lokalnej społeczności.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 col-sm-6">
                                    <div className="our-story-pic-block">
                                        <div className="mt-media our-story-pic">
                                            <img src={require("./../../images/gallery/story/2021 - rozszerzamy park maszyn.jpg")} alt=""/>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8 col-sm-6">
                            <div className="mt-box our-story-detail bg-moving bg-cover" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                <h4 className="text-uppercase m-b20">2021</h4>
                                <h4 className="m-b20">Rozszerzenie parku maszyn</h4>
                                <p>Rozszerzyliśmy nasz park maszyn o własną frezarkę CNC, co pozwoliło nam na jeszcze bardziej precyzyjne i efektywne realizowanie projektów. Inwestycja w nowoczesne technologie umożliwiła nam tworzenie jeszcze bardziej zaawansowanych i wytrzymałych konstrukcji.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-sm-6">
                            <div className="our-story-pic-block">
                                <div className="mt-media our-story-pic">
                                    <img src={require("./../../images/gallery/story/2021 - skatepark w olsztynie.jpg")} alt=""/>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8 col-sm-6">
                            <div className="mt-box our-story-detail bg-moving bg-cover" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                <h4 className="text-uppercase m-b20">2021</h4>
                                <h4 className="m-b20">Skatepark w Olsztynie</h4>
                                <p>Kolejnym dużym projektem było wykonanie skateparku w Olsztynie. Był to nasz drugi znaczący projekt, który umocnił naszą pozycję w branży. Każdy element skateparku został zaprojektowany z myślą o potrzebach użytkowników, co spotkało się z ogromnym uznaniem lokalnej społeczności.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-sm-6">
                            <div className="our-story-pic-block">
                                <div className="mt-media our-story-pic">
                                    <img src={require("./../../images/gallery/story/2023 - igrzyska europejskie.jpg")} alt=""/>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8 col-sm-6">
                            <div className="mt-box our-story-detail bg-moving bg-cover" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                <h4 className="text-uppercase m-b20">2023</h4>
                                <h4 className="m-b20">Skatepark na Igrzyska Europejskie</h4>
                                <p>Największym osiągnięciem było stworzenie skateparku na Igrzyska Europejskie. Ten projekt był naszym dotychczasowym szczytem możliwości i ukoronowaniem lat ciężkiej pracy i zaangażowania. To wielkie wydarzenie było dowodem na to, że nasza pasja i determinacja przynoszą owoce na arenie międzynarodowej.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
);
        
};
}
export default AboutSummary;